export const urlTmpAttachments = {
    computed: {
        urlTmpAttachments(){
            return `${process.env.VUE_APP_API_URL}tmp/uploads/`
        },
    },
}
